import {Getter} from '../getters/getter'
import {DotPath} from '../getOrElse'

export type GetterConfig = {
  [key: string]: GetterWithPath<any, any>
}

export type Decorator<T> = {
  (input: T): T
}

export type Decorators<T> = Decorator<T> | Decorator<T>[]

export type GetterWithPath<R, T> = {
  getter: Getter<R, T>,
  dotPaths?: DotPath,
  decorators?: Decorators<T>
}

export interface GetterConfigArgs  {
  ignorePaths?: DotPath,
  optionalPartialConfig?: GetterConfig
}

export interface Parseable<T> {
  parseJson(json: object, obj?: T, configArgs?: GetterConfigArgs): T
}

export interface Buildable<T> {
  build(args: Partial<T & {json: object}>, configArgs?: GetterConfigArgs)
}

/**
 * Marks a class as having at least a parse
 * and a config available.
 */
export interface ConfigStatic<T> extends Parseable<T> {
  config: GetterConfig
  new(): T
}

/**
 * Marks classes that can be built from a partial type
 * as well as JSON for versatility
 */
export interface BuildStatic<T> extends ConfigStatic<T>, Buildable<T> {}

export interface BuildAndParseStatic<T> extends Parseable<T>, Buildable<T> {}

/* tslint:disable */
/**
 * Experimental decorator that marks classes as
 * implementing static methods and/or members
 */
export function staticImplements<T>() {
  return (consructor: T) => {}
}
/* tslint:enable */
